import { getPageUrl, isLastPage } from '../../productSearch';
import createPaginationStrategy from './createPaginationStrategy';

/**
 * This strategy follows the next flow:
 * 1. When there are more products in a category, return the next page
 * 2. Otherwise, pagination ends (last page has been returned already)
 */
const defaultPaginationStrategy = createPaginationStrategy({
  getNextPageCategoryFn: () => null,
  getNextPageUrlFn: (productSearch) =>
    isLastPage(productSearch)
      ? null
      : getPageUrl(productSearch, productSearch.pageNumber + 1),
  isLastPageFn: (productSearch) => isLastPage(productSearch),
});

export default defaultPaginationStrategy;
